export default __webpack_public_path__ + "static/media/Home_mobile.5a7c4478.png";